import React, { Component } from "react";

import { AsyncTypeahead } from "../../form-inputs/typeahead";
//import { getInhouseCategories } from '../../scheduling/lib/schedulingData';
import { getTypeaheadValues } from "../lib/mock";

class AsyncTypeaheadExamples extends Component {
    constructor(props) {
        super();
        this.state = {
            options: [],
        };
    }

    updateField = (name, value) => {
        /*this.setState({
            [name]: value
        });*/
    };

    render() {
        return (
            <div>
                <h3>Async</h3>
                <AsyncTypeahead name="numbersAsyncTypeahead" label="Categories" defaultValue={this.state.numbersTypeahead} updateOnChange={this.updateField} loadOptions={getTypeaheadValues} multiple={true} />
            </div>
        );
    }
}

export default AsyncTypeaheadExamples;
